import { render, staticRenderFns } from "./UsersTrainingsList.vue?vue&type=template&id=6af5a598&scoped=true&"
import script from "./UsersTrainingsList.vue?vue&type=script&lang=js&"
export * from "./UsersTrainingsList.vue?vue&type=script&lang=js&"
import style0 from "./UsersTrainingsList.vue?vue&type=style&index=0&id=6af5a598&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af5a598",
  null
  
)

export default component.exports